import styled, { css } from 'styled-components';
import _Text from 'src/features/PussInBoots/PussInBootsTopicOfTopicPageContent/Text';
import theme from 'src/utils/theme';

const LearnablesLabel = styled(_Text).attrs({
  $desktopStyles: css`
    font-size: ${theme.DEPRECATED_ty.medium};
    line-height: ${theme.DEPRECATED_ty.larger};
  `,
  $mobileStyles: css`
    font-weight: ${theme.DEPRECATED_ty.bold};
  `,
})(() => css``);

export default LearnablesLabel;
